import { PackageModuleModel } from "./package-module.model";
import { PackageModuleDetailModel } from "./package-module-detail.model";
import { ModuleModel } from "./module.model";

export class PackageModuleViewModel {
    packageModule: PackageModuleModel;
    modules: Array<ModuleModel>;
    packageModuleDetails: Array<PackageModuleDetailModel>;

    totalQuantity: number;
    freeQuantity: number;
    freeQuantityTotal: number;
    subTotal: number;
    discount: number;
    total: number;

    constructor() {
        this.modules = new Array();
        this.packageModuleDetails = new Array();
    }
}